import type { ErrorScreenProps } from "./component-types";

export function ErrorScreen({ message }: ErrorScreenProps) {
  return (
    <div className="container error">
      <div className="error-icon">⚠️</div>
      <h2>Oops, something went wrong</h2>
      <p>{message}</p>
      <button className="button button-primary" onClick={() => window.location.reload()}>
        Try Again
      </button>
    </div>
  );
}
